import React from 'react';
import { action, observable } from "mobx";

export default class CellTransformer {
    transform(value) {
            

        return (
            <div style={{color: 'red'}}>
                <input 
                    type="text" 
                    onChange={(ev)=>{console.log(ev)}} 
                    value={value}
                /> 
            </div>
        );
    }
}